import { ApproveMultipleSourcePayload } from "src/entity/voc-approve/voc-approve.entity";
import http from "../utils/http-common";

const baseVocApprovalPath = "api/voc-approval";

export const getOptionVocApproval = (query: string) => {
  return http.get(`${baseVocApprovalPath}/report/voc-emission/approve/filter-voc-approve?${query}`);
};

export const getInfoStepApproval = (query: string) => {
  return http.get(`${baseVocApprovalPath}/report/voc-emission/approve/info-step?${query}`);
};

export const getAvailableApprovalMonths = (query: string) => {
  return http.get(`${baseVocApprovalPath}/report/voc-emission/approve/months/available?${query}`);
};

export const approveMultipleSource = (data: ApproveMultipleSourcePayload) => {
  return http.post(`${baseVocApprovalPath}/report/voc-emission/approve/multiple-report`, data);
};

export const getCompanyGroupPermission = (query: string) => {
  return http.get(`${baseVocApprovalPath}/report/voc-emission/approve-company-group?${query}`);
};
